module.exports = __webpack_public_path__ + "vue/img/service1.45448c56.svg";